import { render, staticRenderFns } from "./UsersAvailableGroups.vue?vue&type=template&id=83d5bb7e"
import script from "./UsersAvailableGroups.vue?vue&type=script&lang=js"
export * from "./UsersAvailableGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports